import { useTranslations } from '@vocab/react';

import { Toggle } from '../Toggle/Toggle';

import translations from './.vocab';

interface Props {
  isLimitLocationChecked: boolean;
  onChange: (value: boolean) => void;
}

export const LimitLocationToggle = ({
  isLimitLocationChecked,
  onChange,
}: Props) => {
  const { t } = useTranslations(translations);
  return (
    <Toggle
      checked={isLimitLocationChecked}
      onChange={onChange}
      label={t('LIMIT_LOCATION')}
      tooltip={t('LIMIT_LOCATION_TOOLTIP')}
    />
  );
};
